import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output } from '@components/Reference';
import Sandbox from '@components/Sandbox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "cursor"
    }}>{`Cursor`}</h1>
    <p>{`Utility classes to change pointer behaviour`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class reference`}</h2>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name">.c-auto</Name>
        <Output mdxType="Output">pointer: auto;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.c-default</Name>
        <Output mdxType="Output">pointer: default;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.c-pointer</Name>
        <Output mdxType="Output">pointer: pointer;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.c-wait</Name>
        <Output mdxType="Output">pointer: wait;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.c-move</Name>
        <Output mdxType="Output">pointer: move;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.c-not-allowed</Name>
        <Output mdxType="Output">pointer: not-allowed;</Output>
    </Property>
    </Reference>
    <h2 {...{
      "id": "auto"
    }}>{`Auto`}</h2>
    <p><inlineCode parentName="p">{`.c-auto`}</inlineCode>{` changes the cursor depending on the context of the content being hovered on. Example:- cursor becomes a select on hovering over text.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block h-10 bg-secondary-500 ta-center flex flex-center flex-middle">
      <span className="fw-600 c-white">Hover on me</span>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="c-auto">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "default"
    }}>{`Default`}</h2>
    <p><inlineCode parentName="p">{`.c-defaults`}</inlineCode>{` shows the default cursor irrespective of the semantic element it is hovering on.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="c-default d-inline-block h-10 bg-secondary-500 ta-center flex flex-center flex-middle">
      <span className="fw-600 c-white">Hover on me</span>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="c-default">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "pointer"
    }}>{`Pointer`}</h2>
    <p><inlineCode parentName="p">{`.c-pointer`}</inlineCode>{` shows a pointing hand to indicate that an element is clickable.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="c-pointer d-inline-block h-10 bg-secondary-500 ta-center flex flex-center flex-middle">
      <span className="fw-600 c-white">Hover on me</span>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="c-pointer">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "wait"
    }}>{`Wait`}</h2>
    <p><inlineCode parentName="p">{`.c-wait`}</inlineCode>{` shows a spinner to indicate that some background process is taking place.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="c-wait d-inline-block h-10 bg-secondary-500 ta-center flex flex-center flex-middle">
      <span className="fw-600 c-white">Hover on me</span>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="c-wait">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "move"
    }}>{`Move`}</h2>
    <p><inlineCode parentName="p">{`.c-move`}</inlineCode>{` indicates that the element is draggable.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="c-move d-inline-block h-10 bg-secondary-500 ta-center flex flex-center flex-middle">
      <span className="fw-600 c-white">Hover on me</span>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="c-move">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "not-allowed"
    }}>{`Not allowed`}</h2>
    <p><inlineCode parentName="p">{`.c-not-allowed`}</inlineCode>{` indicates that the element cannot be clicked. Sometimes used to prevent accidental clicks.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="c-not-allowed d-inline-block h-10 bg-secondary-500 ta-center flex flex-center flex-middle">
      <span className="fw-600 c-white">Hover on me</span>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="c-not-allowed">...</div>
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      